import { ParsedUrlQuery } from 'node:querystring';
import { getTargetOrigin } from '../lib/redirectRouteToDomain';
import hasExecutivePage from '../lib/hasExecutivePage';
import { Newsboard } from '../lib/graphql/api/graphql';

export interface Item {
  name?: string;
  id: string;
  href?: string;
  router?: boolean;
  params?: ParsedUrlQuery;
  route?: string;
  target?: string;
  executive?: boolean;
}
export interface MenuItem {
  id: string;
  items?: Item[];
  router?: boolean;
  route?: string;
  href?: string;
  params?: ParsedUrlQuery;
  target?: string;
  executive?: boolean;
}

const infoNavigation = [
  {
    id: 'news',
    router: true,
    route: 'news-feed.en-IE',
    items: [],
  },
  {
    id: 'internationalNetwork',
    href: 'https://fashionunited.info/international-network',
    router: true,
    route: 'international-network',
    items: [],
  },
  {
    id: 'about',
    href: 'https://fashionunited.info/about-us',
    router: true,
    route: 'about-us',
    items: [
      {
        id: 'info.about',
        href: 'https://fashionunited.info/about-us',
        router: true,
        route: 'about-us',
      },
      {
        id: 'info.about.mediaReleases',
        router: true,
        route: 'category',
        params: {
          categoryPath: 'news/business',
        },
      },
    ],
  },
  {
    id: 'careers',
    href: 'https://fashionunited.com/fashion-jobs/work-at/fashionunited-jobs',
    items: [],
  },
  {
    id: 'contact',
    href: 'https://fashionunited.info/contact',
    router: true,
    route: 'contact',
    items: [],
  },
  {
    id: 'conditions',
    href: 'https://fashionunited.info/conditions',
    router: true,
    route: 'conditions',
    items: [
      {
        id: 'info.conditions',
        href: 'https://fashionunited.info/conditions',
        router: true,
        route: 'conditions',
      },
      {
        id: 'info.conditions.termsOfUse',
        href: 'https://fashionunited.info/terms-of-use',
        router: true,
        route: 'terms-of-use',
      },
    ],
  },
];

const hasDataSpecialPage = (newsboard: Newsboard) => [
  Newsboard.FASHIONUNITED_NL,
  Newsboard.FASHIONUNITED_BE,
  Newsboard.FASHIONUNITED_DE,
  Newsboard.FASHIONUNITED_UK,
  Newsboard.FASHIONUNITED_FR,
  Newsboard.FASHIONUNITED_ES,
  Newsboard.FASHIONUNITED_IT,
].includes(newsboard);

const getNavigation = (
  newsboard: Newsboard,
  locale: string,
  jobsLanding: boolean,
  lite: boolean,
  hasNews: boolean,
  origin: string,
) : MenuItem[] => (
  newsboard === Newsboard.FASHIONUNITED_INFO ? infoNavigation : [
    {
      id: 'news',
      router: !lite,
      route: `news-feed.${locale}`,
      href: 'https://fashionunited.com/just-in',
    },
    ...(hasExecutivePage(newsboard) ? [
      {
        id: 'executive',
        router: true,
        route: 'executive',
        items: [],
        executive: true,
      },
    ] : []),
    {
      id: 'jobs',
      href: '/fashionjobs',
      router: jobsLanding,
      route: `jobs-landing.${locale}`,
    },
    {
      id: 'marketplace',
      href: `${getTargetOrigin(origin)}/marketplace`,
      router: newsboard === Newsboard.FASHIONUNITED_COM,
      route: 'marketplace',
    },
    {
      id: 'lookbook',
      href: `${getTargetOrigin(origin)}/lookbook`,
      router: newsboard === Newsboard.FASHIONUNITED_COM,
      route: 'lookbook',
    },
    {
      id: 'events',
      router: true,
      route: 'events',
    },
    hasDataSpecialPage(newsboard) ? {
      id: 'data',
      router: true,
      route: 'specials',
      params: { slug: 'data' },
    } : {
      id: 'data',
      href: 'https://fashionunited.com/i',
      router: false,
      route: 'intelligence',
    },
    {
      id: 'trends',
      router: hasNews,
      route: 'trends',
    },
  ]
);

export {
  getNavigation,
  infoNavigation,
};
